import { LoginPage } from '@reactjscomponentrepository/frontend-components/lib/components';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import logotipo from '../images/logotipo_sim.svg';
import sesionService from '@frontend/useradmin/lib/services/SesionService'
import { ISesion } from '@frontend/useradmin/lib/interfaces/Sesion.model';
import { FormEvent } from 'react';

export const Login = () => {
  const navigate = useNavigate();
  const login: ISesion = { idUsuario: 0, usuario: "", contraseña: "", token: "", rol: 0 }

  const usrChange = (event: { target: { value: any; }; }) => {
    login.usuario = event.target.value;
  }

  const pwdChange = (event: { target: { value: any; }; }) => {
    login.contraseña = event.target.value;
  }

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    sesionService.openSesion(login)
      .then((response) => {
        login.token = response.data.contenido.token;
        localStorage.setItem("token", login.token);
        if (response.data.contenido.usuario != null) {
          localStorage.setItem("usuario", response.data.contenido.usuario);
        }
        navigate('/home');
      },
        (rechazado) => {
          toast.error(rechazado.response.data.result.descripcion)
        })
      .catch((error) => {
        toast.error(`Error de autenticación`);
      });
  };

  return (
    <>
      <LoginPage 
        systemImage={logotipo} systemImageAlt='SIM - Sistema Integrador de Metadatos' systemName='SIM: ' 
        systemDescription='Sistema Integrador de Metadatos'
        footerImage=''
        onChangeEmail={usrChange}
        onChangePassword={pwdChange}
        onSubmit={handleSubmit}
        systemDescriptionComplete={<><p className='text-justify mx-5 pt-4'>De conformidad con lo establecido en el artículo 14 de la Norma Técnica para la elaboración de Metadatos de los Procesos de Producción de Información Estadística y Geográfica, el acceso al Sistema Integrador de Metadatos (SIM) está reservado para las personas servidoras públicas designadas como responsables de la captura, revisión y autorización de metadatos.</p></>}
      />
    </>
  )
}